export var Paths;

(function (Paths) {
  Paths["ListGenres"] = "/genres";
  Paths["ListTopics"] = "/topics";
  Paths["ShowGenre"] = "/genres/:genreSlug";
  Paths["ListCountries"] = "/countries";
  Paths["ShowTopic"] = "/topics/:topicSlug";
  Paths["ShowCountry"] = "/countries/:countrySlug";
  Paths["ListGenreVideos"] = "/genres/:genreSlug/videos";
  Paths["ListTopicVideos"] = "/topics/:topicSlug/videos";
  Paths["ListCountryVideos"] = "/countries/:countrySlug/videos";
  Paths["FindCountryVideoIndex"] = "/countries/:countrySlug/video_index";
  Paths["FindTopicVideoIndex"] = "/topics/:topicSlug/video_index";
  Paths["FindGenreVideoIndex"] = "/genres/:genreSlug/video_index";
  Paths["ListSuggestedTags"] = "/suggested_tags";
})(Paths || (Paths = {}));